export enum TaskStatus {
  NEW = "new",
  INFORM = "inform",
  IN_PROGRESS = "in_progress",
  ON_HOLD = "on_hold",
  DONE = "done",
  QA_FAILED = "qa_failed",
  CLOSED = "closed",
}

export enum TaskPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}
